import { SIGN_IN_PRODUCT, SIGN_IN_VIEW, type SignInProduct } from 'common/constants/auth';
import { ACTIVATE_TITLE_LEAD, ACTIVATE_TITLE_TAIL } from 'pages/Auth/ActivateAccount/ActivateAccount.constants';
import { AuthTitleText } from 'pages/Auth/components';
import type { AuthTitleCopy, SignInHeaderTitleProps } from './SignInHeaderTitle.types';
import {
  SIGN_IN_COMPANY_SELECTION_HEADER_LEAD,
  SIGN_IN_COMPANY_SELECTION_HEADER_TAIL,
  SIGN_IN_FIRM_SELECTION_HEADER_LEAD,
  SIGN_IN_FIRM_SELECTION_HEADER_TAIL,
  SIGN_IN_TITLE_LEAD,
  SIGN_IN_TITLE_TAIL,
} from '../../SignIn.constants';

const SIGN_IN_HEADER_COPY_BY_VIEW: Partial<Record<SignInHeaderTitleProps['view'], AuthTitleCopy>> = {
  [SIGN_IN_VIEW.IDENTIFIER]: { lead: SIGN_IN_TITLE_LEAD, tail: SIGN_IN_TITLE_TAIL },
  [SIGN_IN_VIEW.PASSWORD]: { lead: SIGN_IN_TITLE_LEAD, tail: SIGN_IN_TITLE_TAIL },
  [SIGN_IN_VIEW.TERMS]: { lead: ACTIVATE_TITLE_LEAD, tail: ACTIVATE_TITLE_TAIL },
};

const WORKSPACE_HEADER_COPY_BY_PRODUCT = {
  [SIGN_IN_PRODUCT.COMPANY]: {
    lead: SIGN_IN_COMPANY_SELECTION_HEADER_LEAD,
    tail: SIGN_IN_COMPANY_SELECTION_HEADER_TAIL,
  },
  [SIGN_IN_PRODUCT.PORTFOLIO]: {
    lead: SIGN_IN_FIRM_SELECTION_HEADER_LEAD,
    tail: SIGN_IN_FIRM_SELECTION_HEADER_TAIL,
  },
} satisfies Record<SignInProduct, AuthTitleCopy>;

const SignInHeaderTitle = ({
  resolvedProduct,
  shouldHideHeaderTitle,
  view,
}: SignInHeaderTitleProps) => {
  if (shouldHideHeaderTitle) {
    return null;
  }

  const copy = view === SIGN_IN_VIEW.WORKSPACE_SELECTION && resolvedProduct
    ? WORKSPACE_HEADER_COPY_BY_PRODUCT[resolvedProduct]
    : SIGN_IN_HEADER_COPY_BY_VIEW[view];

  return copy ? <AuthTitleText lead={copy.lead} tail={copy.tail} /> : null;
};

export default SignInHeaderTitle;
